import React, { useCallback, useState } from 'react';
import { Box, listItemSelectBuilder, MultiSelect } from '@wix/design-system';
import Avatar from '../PermissionsList/Avatar';
import { debounce } from 'lodash';
export const DashboardMultiSelect = ({ queryFunction, loadOptions, placeholder, isDashboard, onSelect, value = [], shownValues = [], filterShowOnlyInSelectList = false, updatedItems = [], }) => {
    const searchEntityDefaultState = {
        listOptions: [],
        listOptionsData: [],
        isHasMore: true,
        shownValues: [],
    };
    const [searchEntityState, setSearchEntityState] = useState(searchEntityDefaultState);
    const { listOptions, isHasMore, listOptionsData, } = searchEntityState;
    const [searchInputValue, setSearchInputValue] = useState('');
    const [nextCursor, setNextCursor] = useState(null);
    const loadOptionsParams = {
        queryFunction,
        nextCursor,
    };
    const loadData = useCallback((val = '') => {
        let optionsList = listOptions || [];
        const shouldLoad = !nextCursor || nextCursor?.offset < nextCursor?.total;
        if (shouldLoad && loadOptions) {
            const additional = nextCursor ?
                { queryFunction,
                    nextCursor: {
                        count: nextCursor?.count,
                        offset: nextCursor?.offset,
                        total: nextCursor?.total
                    }
                }
                : loadOptionsParams;
            loadOptions(val, listOptionsData, additional).then((response) => {
                const { options, hasMore } = response;
                const newOptions = options?.length ? [...listOptionsData, ...options] : listOptionsData;
                optionsList = (newOptions || []).map((item) => {
                    item.value = item.id;
                    item.label = item.role;
                    item.prefix = (React.createElement(Avatar, { icon: item.icon, isDashboard: isDashboard, name: item.label, imgProps: { src: item.icon } }));
                    item.title = item.label;
                    item.subtitle = item.description;
                    item.overrideOptionStyle = true;
                    return item;
                });
                const listOptionsData2 = optionsList;
                optionsList = optionsList.map((option) => listItemSelectBuilder(option));
                setSearchEntityState({
                    ...searchEntityState,
                    listOptions: optionsList,
                    isHasMore: hasMore,
                    listOptionsData: listOptionsData2,
                });
                setNextCursor(response.additional.nextCursor);
            }).catch((e) => console.log('e', e));
        }
    }, [searchInputValue, nextCursor, listOptionsData]);
    const updateSelectedRoles = (data) => {
        if (onSelect) {
            const newData = data.length >= 2 ? data.filter((item) => !item.showOnlyInSelectList) : data;
            onSelect(newData);
        }
    };
    const handleOnChange = useCallback(debounce((text) => {
        loadData(text);
    }, 600), []);
    const handleOnRemoveTag = (tagId) => {
        const newData = value.filter((tag) => tag.id !== tagId);
        updateSelectedRoles(newData);
    };
    const handleOnSelect = (option) => {
        const existed = value.find((role) => role?.id === siteVisitorsData?.id);
        if (!existed || option?.id !== siteVisitorsData?.id) {
            const selectedOptionData = listOptionsData.find(({ id }) => id === option.id);
            const data = [...value, selectedOptionData];
            updateSelectedRoles(data);
        }
    };
    const siteVisitorsData = listOptionsData.find((item) => item.showOnlyInSelectList);
    const filterSiteVisitors = (obj) => obj?.id !== siteVisitorsData?.id;
    const filteredListOptions = filterShowOnlyInSelectList ? listOptions.filter(filterSiteVisitors) : listOptions;
    const filteredData = filteredListOptions.filter((v, i) => filteredListOptions.findIndex((t) => (t.id === v.id)) === i);
    const filteredSelectedData = filteredData.filter((item) => !updatedItems.some(selectedItem => selectedItem.id === item.id && selectedItem.selectedPermission !== 'NONE'));
    return (React.createElement(Box, { minWidth: '434px', display: 'block', width: filterShowOnlyInSelectList ? '434px' : '660px' },
        React.createElement(MultiSelect, { loadMore: () => {
                setTimeout(() => {
                    loadData(searchInputValue);
                }, 300);
            }, infiniteScroll: true, hasMore: isHasMore, highlight: false, maxNumRows: 3, tags: shownValues, onSelect: handleOnSelect, onRemoveTag: handleOnRemoveTag, onChange: (e) => {
                setSearchInputValue(e.target.value);
                e.persist && e.persist();
                handleOnChange(e.target.value);
            }, value: searchInputValue, options: filteredSelectedData, placeholder: placeholder, minWidthPixels: 350 })));
};
//# sourceMappingURL=DashboardMultiSelect.js.map